import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Collapse';

export default defineMessages({
  deleteItem: {
    id: `${scope}.deleteItem`,
    defaultMessage: 'Delete',
  },
});
